export const state_colors = Object.freeze({
  AVAILABLE: 'rgb(19, 133, 77)',
  RING: '#e03623',
  RINGING: '#DB9513',
  UNPLACED: 'rgb(101, 112, 104)',
  TABULATION_PAUSE: '#f580f4'
});
